import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { FIELD_CLASSES } from './input'

/**
 * A styled native `<select>` — the shared form control matching {@link Input}'s
 * height, border, hover, and focus treatment, with a single chevron affordance.
 * Pass `<option>`s as children. Forwards its ref and all native select props.
 */
/** `size` sets density: `default` (38px, matching Input) or `sm` (30px, for dense
 * rows). Named to shadow the rarely-used native `size` (option-count) attribute. */
type SelectProps = Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> & {
  size?: 'default' | 'sm'
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, size = 'default', ...props },
  ref,
) {
  return (
    <div className="relative">
      <select
        className={cn(
          FIELD_CLASSES,
          'appearance-none pr-9',
          size === 'sm' ? 'h-[30px] pl-2.5 text-control' : 'h-[38px] pl-3',
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" />
    </div>
  )
})
